"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicChannelVideos = void 0;
var tslib_1 = require("tslib");
var video_utils_1 = require("../../../private/services/video/video.utils");
var public_catalog_service_1 = require("../../../catalog-services/public-catalog-service");
var PublicChannelVideos = /** @class */ (function (_super) {
    tslib_1.__extends(PublicChannelVideos, _super);
    function PublicChannelVideos() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PublicChannelVideos.prototype.getList = function (_a, requestConfig) {
        var channelId = _a.channelId, query = _a.query, tag = _a.tag, category = _a.category, mediaType = _a.mediaType, sort = _a.sort, paging = _a.paging, itemType = _a.itemType, templateMetaSiteId = _a.templateMetaSiteId, withPlayInfo = _a.withPlayInfo;
        var params = (0, video_utils_1.mapOptionsToQueryParams)({
            query: query,
            tag: tag,
            category: category,
            mediaType: mediaType,
            sort: sort,
            paging: paging,
            itemType: itemType,
            templateMetaSiteId: templateMetaSiteId,
            withPlayInfo: withPlayInfo,
        });
        return this.get("/public/lists/".concat(channelId), tslib_1.__assign({ params: params }, requestConfig));
    };
    PublicChannelVideos.prototype.getChannelVideoById = function (channelId, videoId, requestConfig) {
        return this.get("/public/lists/".concat(channelId, "/items/").concat(videoId, "/info"), requestConfig);
    };
    return PublicChannelVideos;
}(public_catalog_service_1.PublicCatalogService));
exports.PublicChannelVideos = PublicChannelVideos;
//# sourceMappingURL=channel-videos.js.map